$(document).ready(function() {

  $('.header__logo img').click(function() {
    var text = $('#content .text__continue'),
      animateTime = 500;

    $('#content').toggleClass('expand');
    if (text.height() === 0) {
      autoHeightAnimate(text, animateTime);
      $('#content').find('.more__text').text('zwiń szczegóły');
    }

    $('html, body').animate({
      scrollTop: $('#contact').offset().top
    }, 2000);
  });


  $('.menu__list .menu__item').click(function() {
    $('body').addClass('noscroll');
    $('.menu__item, .fixed__section').removeClass('active');
    $(this).addClass('active');
    var name = $(this).attr('data-name');

    $('#content__' + name).addClass('active');
  });

  $('.btn--back').click(function() {
    $('.fixed__section').removeClass('active');
    setTimeout(function() {
      $('body').removeClass('noscroll');
    }, 400);
  });


  var text = $('#content').find('.text__continue'),
    animateTime = 500,
    btn = $('#content').find('.btn--expand');

  btn.click(function() {
    $('#content').toggleClass('expand');
    if (text.height() === 0) {
      autoHeightAnimate(text, animateTime);
      $('#content').find('.btn__text').text('zwiń szczegóły');
    } else {
      text.stop().animate({
        height: '0'
      }, animateTime);
      $('#content').find('.btn__text').text('więcej informacji');
    }
  });

  /* Function to animate height: auto */
  function autoHeightAnimate(element, time) {
    var curHeight = element.height(), // Get Default Height
      autoHeight = element.css('height', 'auto').height(); // Get Auto Height
    element.height(curHeight); // Reset to Default Height
    element.stop().animate({
      height: autoHeight
    }, time); // Animate to Auto Height
  }

  $('.menu__hamburger').click(function() {
    $('.header__menu').toggleClass('open');
  });



});


(function($) {
  $.fn.alterClass = function(removals, additions) {
    var self = this;

    if (removals.indexOf('*') === -1) {
      // Use native jQuery methods if there is no wildcard matching
      self.removeClass(removals);
      return !additions ? self : self.addClass(additions);
    }

    var patt = new RegExp('\\s' +
      removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') +
      '\\s', 'g');

    self.each(function(i, it) {
      var cn = ' ' + it.className + ' ';
      while (patt.test(cn)) {
        cn = cn.replace(patt, ' ');
      }
      it.className = $.trim(cn);
    });

    return !additions ? self : self.addClass(additions);
  };
})(jQuery);
